import React from "react";
import { CircleX } from "lucide-react";

interface ErrorBannerProps {
    message: string;
    onClose?: () => void;
    containerClassName?: string;
    bannerClassName?: string;
    closeLabel?: string;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
    message,
    onClose,
    containerClassName = "w-full sm:max-w-[430px] mb-4",
    bannerClassName = "border border-red-200 bg-red-50 text-white rounded-md px-4 py-3 text-left flex items-start gap-3",
    closeLabel = "Close error banner"
}) => {
    return (
        <div className={containerClassName}>
            <div
                role="alert"
                aria-live="assertive"
                className={bannerClassName}
                style={{
                    background: "var(--vds-color-feedback-background-error-tonal, #ff1b1b)",
                    color: "#FFFFFF"
                }}
            >
                {onClose && (
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label={closeLabel}
                        className="mt-0.5 shrink-0 w-5 h-5 text-white hover:text-white flex items-center justify-center"
                    >
                        <CircleX />
                    </button>
                )}
                <span>{message}</span>
            </div>
        </div>
    );
};

export default ErrorBanner;